'use strict';

export default class MemAtrTypeViewCtrl {
  constructor($stateParams, $state, MemAtrTypeSvc, GroupAuthSvc, LoaderSvc) {
    var that = this;
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // current group
    this.maId = $stateParams.maId;

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberAttributeType', 'R');

    if(!this.maId) {
      return $state.go('group.view.settings.memberAttributeType.list');
    }
    //load memberAttribute
    function loadMemAtrType() {
      LoaderSvc.start();
      MemAtrTypeSvc.get({groupId: that.groupId, id: that.maId}).$promise
        .then(function(memberAttribute) {
          that.memberAttribute = memberAttribute;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Member Attribute');
        });
    }
    loadMemAtrType();
  }
}

MemAtrTypeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'MemAtrTypeSvc',
  'GroupAuthSvc',
  'LoaderSvc'
];
